// eslint-disable-next-line camelcase
import { NavigateFunction, NavigateOptions, To } from 'react-router'

export let navigate: NavigateFunction = null
export function initGlobalRouter(nav: NavigateFunction) {
  navigate = (to: To | number, options?: NavigateOptions) => {
    if (typeof to === 'number') {
      return nav(to)
    }

    return nav(to, options)
  }
}
